import { useState, useContext, createContext, useMemo, useEffect } from "react";
import { Button, TextField, IconButton, Modal, MenuItem } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { Context } from "../DashCrearSolicitudCredito";
import Swal from "sweetalert2";
import HouseIcon from "@mui/icons-material/House";
import request from "../../../../../Helpers/API";
import { GetKey, GetText } from "../../../../../Helpers/GetKey";
import SearchIcon from "@mui/icons-material/Search";
import { ValFormReg } from "../../../../../Validators/ValForms";
import { RegularExpressions } from "../../../../../Helpers/RegularExpression";
import { ValOnlyNumber } from "../../../../../Validators/ValOnlyNumber";
import { ValTextAndNumber } from "../../../../../Validators/ValTextAndNumber";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { ValSpecialCharacters } from "../../../../../Validators/ValSpecialCharacters";

const ContextDomicilio = createContext(null);

export default function SolicitudDeCreditoDomicilio({
  value,
  onNext,
  screen,
  setValue,
  setScreen,
  setBotonSiguiente,
}) {
  const { state } = useContext(Context);
  const [domicilios, setDomicilios] = useState([]);
  const [stateDomicilio, setStateDomicilio] = useState({
    formDatos: {
      orden: -1,
      idlocalidad: "",
      direccion: "",
      tipodomicilio: "",
      principal: "",
      referencia1: "",
      referencia2: "",
      estatus: 1,
      estado: "",
      municipio: "",
      cp: "",
    },
    principal: {
      SI: true,
      NO: false,
    },
    tipodomicilio: {
      FISCAL: "F",
      OFICINA: "O",
      CASA: "C",
    },
    localidadesDropDownList: [],
    open: false,
  });

  const contextValue = useMemo(
    () => ({
      stateDomicilio,
      setStateDomicilio,
    }),
    [stateDomicilio, setStateDomicilio]
  );
  useEffect(() => {
    setBotonSiguiente(() => (
      <div
        className="footer-solicitud-credito-guardar"
        onClick={() => Number(screen) >= 0 && setValue(3)}
      >
        Siguiente <ArrowForwardIcon />
      </div>
    ));
  }, []);
  useEffect(() => {
    // setLoader({ ...loader, mostrar: true });
    request
      .get(`ClientesDomicilio/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setDomicilios(result);
        // setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  }, []);

  const openModal = () => {
    setStateDomicilio({
      ...stateDomicilio,
      open: true,
      formDatos: {
        orden: -1,
        idlocalidad: "",
        direccion: "",
        tipodomicilio: "",
        principal: "",
        referencia1: "",
        referencia2: "",
        estatus: 1,
        estado: "",
        municipio: "",
        cp: "",
      },
    });
  };

  const openEditardomicilio = (domicilio) => {
    const tipoDomicilioInicial = domicilio.tipodomicilio;
    const tipoDomicilioModificado = tipoDomicilioInicial.charAt(0);
    setStateDomicilio({
      ...stateDomicilio,
      open: true,
      formDatos: {
        cp: domicilio.codigo_postal,
        direccion: domicilio.direccion,
        estado: domicilio.estado,
        estatus: domicilio.estatus,
        orden: domicilio.orden,
        idcliente: state.idCliente,
        idlocalidad: domicilio.idlocalidad,
        tipodomicilio: tipoDomicilioModificado,
        principal: domicilio.principal,
        referencia1: domicilio.referencia1,
        referencia2: domicilio.referencia2,
        municipio: domicilio.municipio,
      },
    });
  };

  const capitalizeWords = (str) => {
    return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
  }; 

  return (
    <ContextDomicilio.Provider value={contextValue}>
      <Button
        onClick={openModal}
        startIcon={<AddIcon />}
        variant="contained"
        fullWidth
        style={{ marginBottom: 10 }}
      >
        Agregar domicilio
      </Button>

      <ModalAgregar
        setDomicilios={setDomicilios}
        // loader={loader}
        // setLoader={setLoader}
        screen={screen}
        setScreen={setScreen}
      />

      <div className="dash-clientes-container-table-direccion scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <thead>
            <tr>
              <th>Municipio</th>
              <th>Estado</th>
              <th>CP</th>
              <th>Dirección</th>
              <th>Colonia</th>
              <th>Tipo</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {domicilios.map((domicilio, i) => (
              <tr
                key={i + 1}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <td>{capitalizeWords(domicilio.municipio)}</td>
                <td>{capitalizeWords(domicilio.estado)}</td>
                <td>{domicilio.codigo_postal}</td>
                <td>{capitalizeWords(domicilio.direccion)}</td>
                <td>{capitalizeWords(domicilio.localidad)}</td>
                <td>{GetText(domicilio.tipodomicilio)}</td>
                <td>
                  <IconButton
                    onClick={() => {
                      openEditardomicilio(domicilio);
                    }}
                    color="warning"
                  >
                    <EditIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ContextDomicilio.Provider>
  );
}

// Componente para el modal de agregar un nuevo domicilio
function ModalAgregar({ setDomicilios, screen, setScreen }) {
  // Utilizamos el contexto de los domicilios y de la solicitud de crédito
  const { stateDomicilio, setStateDomicilio } = useContext(ContextDomicilio);
  const { state, setState } = useContext(Context);
  // Función para cerrar el modal
  const closeModal = () => {
    setStateDomicilio({
      ...stateDomicilio,
      open: false,
      formDatos: {
        orden: -1,
        idlocalidad: "",
        direccion: "",
        tipodomicilio: "",
        principal: "",
        referencia1: "",
        referencia2: "",
        estatus: 1,
        estado: "",
        municipio: "",
        cp: "",
      },
    });
  };

  // Función para recargar la tabla de domicilios
  const recargarTablaDomicilios = () => {
    request
      .get(`ClientesDomicilio/Listado?idcliente=${state.idCliente}`)
      .then((result) => {
        setDomicilios(result);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "SOLICITUD DE CREDITO",
          text: `${JSON.stringify(error)}`,
        });
      });
  };

  // Función para agregar un nuevo domicilio
  const agregarDomicilio = (datos) => {
    // setLoader({ ...loader, mostrar: true });
    // Validar los campos utilizando las funciones de validación
    const cpValidation = ValFormReg(
      "Codigo Postal",
      datos.cp,
      RegularExpressions.TextOnlyNumber
    );
    const idLocalidadValidation = ValFormReg(
      "Localidad",
      datos.idlocalidad,
      RegularExpressions.TextOnlyNumber
    );
    const tipoDomicilioValidation = ValFormReg(
      "Tipo de Domicilio",
      datos.tipodomicilio,
      RegularExpressions.TextAndNumber
    );
    const direccionValidation = ValFormReg(
      "Direccion",
      datos.direccion,
      RegularExpressions.TextSpecialCharacter
    );

    // Verificar si alguna validación falla
    if (
      !cpValidation.isValid ||
      !idLocalidadValidation.isValid ||
      !tipoDomicilioValidation.isValid ||
      !direccionValidation.isValid
    ) {
      // setLoader({ ...loader, mostrar: false });
      // Mostrar mensajes de error
      Swal.fire({
        icon: "error",
        title: "SOLICITUD DE CREDITO",
        html: `
          ${cpValidation.mensaje}
          ${idLocalidadValidation.mensaje}
          ${tipoDomicilioValidation.mensaje}
          ${direccionValidation.mensaje}
        `,
      });
      return; // Detener la función si hay errores de validación
    }

    datos.idcliente = state.idCliente;

    request
      .post("ClientesDomicilio", datos)
      .then(() => {
        recargarTablaDomicilios();
      })
      .then(() => {
        // setLoader({ ...loader, mostrar: false });
        closeModal();
        var habScreen = Number(screen) >= 3 ? screen : 2;
        setScreen(habScreen);
        Swal.fire({
          title: "SOLICITUD DE CREDITO",
          html: "Datos cargados con éxito",
          icon: "success",
        });
      })
      .catch((error) => {
        // setLoader({ ...loader, mostrar: false });
        Swal.fire("SOLICITUD DE CREDITO", JSON.stringify(error), "error");
      });
  };

  // Función para actualizar un campo del formulario
  const actualizarCampo = (event, value) => {
    setStateDomicilio({
      ...stateDomicilio,
      formDatos: {
        ...stateDomicilio.formDatos,
        [event.target.name]: event.target.value,
      },
    });
  };
  const buscarLocalidades = () => {
    const codigoPostal = stateDomicilio.formDatos.cp;

    // Verificar si el código postal está presente
    if (!codigoPostal) {
      Swal.fire({
        icon: "error",
        title: "SOLICITUD DE CREDITO",
        text: "Debe ingresar un código postal primero",
      });
      return;
    }

    request
      .get(`Localidades/Listado?codigo_postal=${codigoPostal}`)
      .then((result) => {
        // Verificar si se encontraron localidades
        if (result.localidades.length === 0) {
          Swal.fire({
            icon: "error",
            title: "SOLICITUD DE CREDITO",
            text: "Ingrese un código postal válido",
          });
          return;
        }

        setStateDomicilio((prevState) => ({
          ...prevState,
          localidadesDropDownList: result.localidades,
          formDatos: {
            ...stateDomicilio.formDatos,
            estado: result.estado.estado,
            municipio: result.estado.municipio,
          },
        }));
      })
      .catch((error) => {
        // Manejar errores si es necesario
        console.error(error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: `Algo salió mal: ${error.Mensaje}`,
        });
      });
  };
  const onChange = (prop, value, sbool, smensaje) => {
    setStateDomicilio({
      ...stateDomicilio,
      formDatos: {
        ...stateDomicilio.formDatos,
        [prop]: value,
      },
    });
  };
  // Renderizado del componente
  return (
    <Modal open={stateDomicilio.open} className="position-z-index">
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <div className="dash-clientes-credito-crear-solicitud-modal-header">
          <div className="dash-clientes-credito-crear-solicitud-modal-header-title">
            <HouseIcon />
            <div>
              {stateDomicilio.formDatos.orden === -1
                ? "AGREGAR NUEVO "
                : "EDITAR "}
              DOMICILIO
            </div>
          </div>
          <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto">
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-bl"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-circle"></div>
            <div className="dash-clientes-credito-crear-solicitud-modal-header-efecto-br"></div>
          </div>
        </div>
        <div className="dash-clientes-credito-crear-solicitud-form-container">
          <div className="mid">
            <TextField
              fullWidth
              size="small"
              label="Codigo Postal"
              variant="outlined"
              name="cp"
              onChange={({ target }) => {
                ValOnlyNumber("cp", target.value, onChange, true, 5);
              }}
              value={stateDomicilio.formDatos.cp}
            />
            <Button
              style={{ textAlign: "center" }}
              startIcon={<SearchIcon />}
              variant="contained"
              size="small"
              fullWidth
              onClick={buscarLocalidades}
            >
              Buscar
            </Button>
            <TextField
              fullWidth
              size="small"
              label="Estado"
              variant="outlined"
              name="estado"
              disabled
              value={stateDomicilio.formDatos.estado}
            />
            <TextField
              fullWidth
              size="small"
              label="Municipio"
              variant="outlined"
              name="municipio"
              disabled
              value={stateDomicilio.formDatos.municipio}
            />
          </div>
          <div className="full">
            <TextField
              fullWidth
              size="small"
              label="Localidad"
              variant="outlined"
              name="idlocalidad"
              onChange={actualizarCampo}
              value={stateDomicilio.formDatos.idlocalidad}
              select
            >
              {stateDomicilio.localidadesDropDownList.map((localidad) => {
                return (
                  <MenuItem key={localidad.id} value={localidad.id}>
                    {localidad.display}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          <div className="mid">
            <TextField
              fullWidth
              size="small"
              label="Tipo"
              variant="outlined"
              name="tipodomicilio"
              select
              onChange={actualizarCampo}
              value={GetKey(stateDomicilio.formDatos.tipodomicilio)}
            >
              {Object.keys(stateDomicilio.tipodomicilio).map((item) => {
                return (
                  <MenuItem
                    key={stateDomicilio.tipodomicilio[item]}
                    value={stateDomicilio.tipodomicilio[item]}
                  >
                    {item}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
              fullWidth
              size="small"
              label="¿Es su domicilio principal?"
              variant="outlined"
              name="principal"
              select
              onChange={actualizarCampo}
              value={stateDomicilio.formDatos.principal}
            >
              {Object.keys(stateDomicilio.principal).map((item) => {
                return (
                  <MenuItem
                    key={stateDomicilio.principal[item]}
                    value={stateDomicilio.principal[item]}
                  >
                    {item}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>
          <div className="full">
            <TextField
              fullWidth
              label="Dirección"
              name="direccion"
              value={stateDomicilio.formDatos.direccion}
              multiline
              rows={2}
              onChange={({ target }) => {
                ValSpecialCharacters(
                  "direccion",
                  target.value,
                  onChange,
                  true,
                  200
                );
              }}
            />
          </div>
          <div className="mid">
            <TextField
              label="Referencia 1"
              value={stateDomicilio.formDatos.referencia1}
              multiline
              name="referencia1"
              rows={2}
              onChange={({ target }) => {
                ValSpecialCharacters(
                  "referencia1",
                  target.value,
                  onChange,
                  true,
                  100
                );
              }}
            />
            <TextField
              label="Referencia 2"
              value={stateDomicilio.formDatos.referencia2}
              multiline
              name="referencia2"
              rows={2}
              onChange={({ target }) => {
                ValSpecialCharacters(
                  "referencia2",
                  target.value,
                  onChange,
                  true,
                  100
                );
              }}
            />
          </div>
          <div className="mid dash-clientes-credito-crear-solicitud-modal-button-container">
            <Button onClick={closeModal} variant="contained" color="error">
              Cerrar
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                agregarDomicilio(stateDomicilio.formDatos);
              }}
            >
              {stateDomicilio.formDatos.orden === -1 ? "Agregar" : "Editar"}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
